$(document).ready(function() {

  function setEqualHeight(columns) {
    $(columns).height('auto');
    var maxHeight = 0;

    $(columns).each(function(){
      if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });

    $(columns).height(maxHeight);
  }

  setEqualHeight($('.review--textitem > div'));
  setEqualHeight($('.review--textitem > p'));

  setTimeout(function(){
    setEqualHeight($('.review--textitem > div'));
    setEqualHeight($('.review--textitem > p'));
  }, 1000);

  $(window).resize(function(){
    setEqualHeight($('.review--textitem > div'));
    setEqualHeight($('.review--textitem > p'));
  });

  $.fn.BeerSlider = function ( options ) {
    options = options || {};
    return this.each(function() {
      new BeerSlider(this, options);
    });
  };
  $('.beer-slider').BeerSlider({start: 50});

  $('.prod-grid').slick({
      arrows:false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay : false,
      dots:true,
      
  });

  $('.media-news-slider').slick({    
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9 17L1 9L9 1"></path> </svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9 17L1 9L9 1"></path> </svg></button>',
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  
  $('.be-af-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.res-img-gall').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
        autoplay: true,
    arrows: false,
    dots: false,
    fade: true,
    autoplaySpeed: 2000,
  });

  $('.results-filters a').click(function(){
    $('.results-filters a').removeClass('active');
    $(this).addClass('active');
    $('.results-section-with-filters .review--griditem').hide();
    $('.results-section-with-filters .'+ $(this).attr('data-tag')).show();
    $('.res-img-gall').slick('refresh');
  });

  /*
  $('.res-img-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    swipe: false,
    asNavFor: '.be-af-slider',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  */

     $('.custom_slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
       adaptiveHeight: true,
      arrows: false,
      dots: true,
       responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 701,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    });

  $('.prod_brand_values').slick({
      infinite: true,
      slidesToShow: 8,
      slidesToScroll: 4,
      arrows: false,
      dots: true,    
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        }
      }
    ]
    });

  
  $('.shades-bar').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg></button>',
      nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg></button>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 540,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  
  $('.logo-bar').slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 3,
      arrows: false,
      dots: true,  
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      }
    ]
    });

  $('.symbol-slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: true,    
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    });

   if (window.matchMedia('(max-width: 767px)').matches) {
      $('label[for="CartNote"]').click(function(){
        $(this).next().toggle();
      });
   }

   if (window.matchMedia('(max-width: 900px)').matches) {
    $('.video-reviews.featured-video-review .results-blocks').slick({
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: true,    
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    });
  }
  
   if (window.matchMedia('(max-width: 768px)').matches) {
    $('.section-product-page.product-benefits .grid').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      dots: true,    
      responsive: [
        {
          breakpoint: 540,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        }
      ]
    });
  }

  
  $('.img-txt-nav-slider').slick({
      arrows:false,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true      
  });

  document.getElementById('skintone-selector').addEventListener('change', function() {
    const selectedValue = this.value;

    const items = document.querySelectorAll('.shades-bar-select');

    items.forEach(item => {
        if (item.getAttribute('data-index') === selectedValue) {
            item.classList.add('selected');
          setTimeout(function() {
            $('.shades-bar').slick('refresh');
            }, 500);
        } else {
            item.classList.remove('selected');
        }
    });
  });
  
});

